<template>
  <div class='image'>

      <figure>
        <img :src="Img" alt="">
      </figure>


  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'CenterFigure',
  components: {
  },
  props: {
    Img: {
      type: String,
    },
  },
}
</script>
<style lang="css" scoped>

.image{
    display:flex;
    justify-content: center;
    margin:1.5rem 0 3rem 0;
}

figure {
    width: 100%;
    display: inline-block;
    text-align: center;
    
    
  }
</style>